import { GraphqlStoreBase } from "../GraphqlStoreBase";
import gql from "graphql-tag";
const latestSensorValuesStoreDocument = gql `
  query LatestSensorValuesStore {
    getLatestSensorValues {
      id
      deviceTime
      temperature
    }
  }
`;
export class LatestSensorValuesStore extends GraphqlStoreBase {
    constructor(authStore, apolloClient) {
        super("LatestSensorValues", authStore, apolloClient, latestSensorValuesStoreDocument, (queryData) => {
            return queryData.getLatestSensorValues;
        }, (latestValue) => {
            // Rehydrate Date types
            return Object.assign(Object.assign({}, latestValue), { deviceTime: new Date(latestValue.deviceTime) });
        });
    }
}
//# sourceMappingURL=index.js.map